type ECSymbolType = 'circle' | 'rect' | 'roundRect' | 'triangle' | 'diamond' | 'pin' | 'arrow';

type ECLineType = 'solid' | 'dashed' | 'dotted';

export const ECHARTS_SYMBOLS: ReadonlyArray<ECSymbolType> = Object.freeze([
  'circle',
  'rect',
  'roundRect',
  'triangle',
  'diamond',
  'pin',
  'arrow',
]);

export const ECHARTS_LINE_TYPES: ReadonlyArray<ECLineType> = Object.freeze(['solid', 'dashed', 'dotted']);
